import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceVideoFleetSettings } from '../../services/VideoService';
import { DeviceVideoSettings } from '../../types/Videos';

function useGetDeviceVideoFleetSettings(fleetId: string): UseQueryResult<DeviceVideoSettings> {
  return useQuery(
    ['device-video-settings', fleetId],
    async (): Promise<DeviceVideoSettings> => getDeviceVideoFleetSettings(fleetId),
    {
      retry: 0,
      retryDelay: 1000,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !!fleetId,
    },
  );
}

export default useGetDeviceVideoFleetSettings;
